import { useEffect } from 'react';

const SEO = () => {
  useEffect(() => {
    // Add JSON-LD Structured Data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "GOS MÉDIA",
      "image": "https://www.gosmediardc.com/logo.png",
      "description": "Photographe et vidéaste professionnel spécialisé dans la couverture d'événements : mariages, dots, conférences et événements gouvernementaux à Lubumbashi et Kolwezi.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Lubumbashi",
        "addressRegion": "Haut-Katanga",
        "addressCountry": "CD"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "-11.6645",
        "longitude": "27.4794"
      },
      "url": "https://www.gosmediardc.com",
      "telephone": "+243999006868",
      "email": "gosmediapro@gmail.com",
      "priceRange": "$130 - $1,300",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "08:00",
        "closes": "20:00"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Lubumbashi"
        },
        {
          "@type": "City",
          "name": "Kolwezi"
        }
      ],
      "serviceType": [
        "Photographie de mariage",
        "Vidéographie de mariage",
        "Couverture événementielle",
        "Photographie de dot",
        "Vidéographie professionnelle"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "150"
      },
      "sameAs": [
        "https://www.facebook.com/gosmediardc",
        "https://www.instagram.com/gosmediardc",
        "https://wa.me/243999006868"
      ]
    });
    
    document.head.appendChild(script);
    
    return () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return null;
};

export default SEO;
